// TODO(yangqing): rename to Tabs.js

var $ = require('jquery')

function autoSplatJqueryElements(elements) {
  if (elements instanceof $) {
    return elements.map(function(index, el) {
      return $(el)
    })
  }
  return elements
}

function Tabs(handlers, contents) {
  var self = this
  this.handlers = autoSplatJqueryElements(handlers)
  this.contents = autoSplatJqueryElements(contents)

  $.each(this.handlers, function(handlerIndex, elem) {
    $(elem).on('click', function() {
      self.turnTo(handlerIndex)
    })
    $(elem).data('tab_index', handlerIndex)
  })
}

Tabs.dummyContent = {
  show: $.noop,
  hide: $.noop,
  trigger: $.noop,
  on: $.noop
}

$.extend(Tabs.prototype, {
  turnTo: function(tabIndex) {
    tabIndex = (tabIndex < 0 ? 0 : tabIndex)
    if (this.currentIndex === tabIndex) {
      return
    }
    this.currentIndex = tabIndex
    $.each(this.contents, $.proxy(function(contentIndex, content) {
      var action = contentIndex === tabIndex ? 'show' : 'hide'
        , handler = this.handlers[contentIndex]
      content[action]()
      content.trigger("tab:" + action)

      if (!handler) { return }
      var handlerFn = handler[action === 'show' ? 'addClass' : 'removeClass']
      if (typeof handlerFn === 'function') {
        handlerFn.call(handler, 'tab-activated current')
      }
    }, this))
  }
, initState: function(tabIndex) {
    this.currentIndex = null
    this.turnTo(tabIndex)
  }
})

module.exports = Tabs;
